import request from 'utils/request_ajax';
import { routes, TYPES } from 'constants/config';
import { PATH_BUILDER } from 'constants/actionTypes';

const makeMappingAction = ACTION => mapping => ({
  type: PATH_BUILDER.RELATED_URLS[ACTION],
  mapping,
});

const actions = {
  createMapping: makeMappingAction('CREATE'),
  removeMapping: makeMappingAction('REMOVE'),
};

const api = {
  create: data => request.postJSON(routes.RELATED_URL_MAPPINGS, data),
  delete: mapping => request.delete(routes.RELATED_URL_MAPPING(mapping.id)),
};

export function createRelatedUrlMapping(relatedUrlOrKeyword) {
  return (dispatch, getState) => {
    const relatedUrlMapping = {
      relatedUrlId: relatedUrlOrKeyword.id,
      contentId: getState().pathBuilder.id,
      contentType: TYPES.PATH,
    };
    api.create({ relatedUrlMapping }).then(mapping => {
      dispatch(actions.createMapping(mapping));
    });
  };
}

export function removeRelatedUrlMapping(mapping) {
  return dispatch => {
    api.delete(mapping).then(() => {
      dispatch(actions.removeMapping(mapping));
    });
  };
}
